var map = {
	"../pages/add-item/add-item.module": [
		403,
		3
	],
	"../pages/edit-item/edit-item.module": [
		404,
		2
	],
	"../pages/items-list/items-list.module": [
		405,
		1
	],
	"../pages/login/login.module": [
		406,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 186;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 186
// module chunks = 4